import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "containerMessage",
  class: "relative flex-1 overflow-y-scroll overflow-x-hidden z-10 bg-white px-4"
}
const _hoisted_2 = { class: "absolute bottom-10 right-10" }
const _hoisted_3 = {
  key: 1,
  class: "bg-white transition-opacity min-h-96 h-full"
}
const _hoisted_4 = { class: "py-28 px-6 flex flex-col items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-300 text-xs" }, "Carregando o chat...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoUser = _resolveComponent("PhotoUser")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.chatmessages.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatmessages, (message, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex mt-4 w-full"
          }, [
            (message.type === 'received' && false)
              ? (_openBlock(), _createBlock(_component_PhotoUser, {
                  key: 0,
                  photo: _ctx.attendance.photo,
                  user: _ctx.attendance.name
                }, null, 8, ["photo", "user"]))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent(message.component), {
              modelValue: message.content,
              "onUpdate:modelValue": ($event: any) => ((message.content) = $event),
              onOnClick: _ctx.handleClickMessage,
              onClickInteract: _ctx.handleClickInteract
            }, null, 40, ["modelValue", "onUpdate:modelValue", "onOnClick", "onClickInteract"]))
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.scrollToEnd(), ["stop","prevent"])),
            class: "go_down webchat-transition",
            style: _normalizeStyle(`background-color: ${_ctx.bgColor}`)
          }, [
            _createVNode(_component_Icon, {
              size: "15",
              name: "ChevronDown"
            })
          ], 4), [
            [_vShow, _ctx.toogleScroll]
          ])
        ])
      ], 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Icon, {
            name: "LoadingCircle",
            size: "60",
            color: "gray"
          }),
          _hoisted_5
        ])
      ]))
}